import links from 'dummyData/headerLinks'

const headerLinksSort = (item, featuredSingleLinks) => {
    const headerLinks = links(featuredSingleLinks)
    return headerLinks.find((headerLink) => headerLink.title === item.title)
        ?.link
}
export default headerLinksSort
